import { Settings } from "./settings.model";

export class Company {
    id: string;
    logo: string;
    name: string;
    address: string;
    identifier: string;
    date: Date;
    settings
    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/model/company.ts